import React from 'react'

function BestAdSet() {
  return (
    <div>BestAdSet</div>
  )
}

export default BestAdSet